import { supabase } from './supabase.js';

/**
 * Journal des actions sensibles sur une préparation.
 *
 * Pourquoi : jusqu'ici, une fiche de livraison pouvait être vidée de ses
 * caisses, de ses photos et de ses anomalies sans qu'aucune trace ne dise qui,
 * ni quand. Sur 60 jours, 122 livraisons réellement parties ont été vidées
 * après leur départ, et il est impossible de savoir par qui.
 *
 * On enregistre donc toute action qui modifie ou détruit : validation de
 * départ, suppression, libération avec effacement, correction de compteurs,
 * ajout ou retrait d'une caisse, annulation d'une livraison.
 *
 * L'écriture ne bloque jamais le travail : si le journal échoue, la bannière
 * rouge globale le signale (intercepteur de lib/supabase.js) et l'action se
 * poursuit — mais on ne perd pas l'information en silence.
 */

export const ACTIONS = {
  DEPART_VALIDE: 'depart_valide',
  SUPPRESSION: 'suppression',
  PRISE: 'prise',                      // « Je prends cette pharmacie »
  LIBERATION: 'liberation',
  EFFACEMENT: 'effacement',            // libération AVEC destruction des données
  CORRECTION: 'correction_compteurs',
  CAISSE_AJOUT: 'caisse_ajout',
  CAISSE_RETRAIT: 'caisse_retrait',
  ANNULATION: 'annulation_livraison',  // livraison déjà partie, annulée avec motif
};

export async function journaliser(action, { session, user, detail = null, motif = null } = {}) {
  try {
    const { error } = await supabase.from('elixir_prep_journal').insert({
      session_id: session?.id || null,
      partner_name: session?.partner_name || null,
      date_prepa: session?.date || null,
      action,
      detail,
      motif,
      user_id: user?.id || null,
      user_name: user?.name || null,
    });
    if (error) console.warn('journal:', error.message);
  } catch (e) {
    console.warn('journal:', e?.message || e);
  }
}

/** Une livraison déjà validée au départ est un fait : on ne la détruit plus. */
export function estPartie(session) {
  return !!session?.validated_at || session?.status === 'depart_valide';
}
